export default {
  highlightProductTitle: 'Prodotti novità',
  projectTitle: 'Progetti',
  bespokeTitle: 'Bespoke',
}
